// extracted by mini-css-extract-plugin
export default {"permissionTeyzeTooltip":"waAHKjho8zRBDTiEtm8e"};